import {CashPointEntryState} from "./_enums/cash-point-entry-state";

export class CashPointEntryFilters {
  ids: string[] | undefined;
  states: CashPointEntryState[] | undefined;
  serialNumbers: string[] | undefined;
}
